import { render } from "./InputMultipleChoiceDev.vue?vue&type=template&id=08bafdb2"
import script from "./InputMultipleChoiceDev.vue?vue&type=script&lang=js"
export * from "./InputMultipleChoiceDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__